import { createSelector } from 'reselect';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { getUserItemsById, getItemsFactory } from 'state/items/selectors';
import { transformItemDtosToProductItems } from 'data/transformers/product-item';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getVasGalleryBannerUiState = state => localState(state).vasGalleryBanner.uiState;
export const getVasGalleryBannerItems = state => localState(state).vasGalleryBanner.items;
export const getVasGalleryAbTest = createSelector(getAbTestByName('vas_gallery_iteration1_v2'), abTest => ({
  visible: abTest && abTest.variant !== 'off',
  variant: abTest === null || abTest === void 0 ? void 0 : abTest.variant
}));
export const getCurrentVasGalleryOrder = state => localState(state).vasGalleryOrder;
export const getSelectedIds = state => localState(state).selectedIds;
export const getVasGalleryCheckout = state => localState(state).vasGalleryCheckout;
export const getSelectedItems = getItemsFactory(getSelectedIds, getUserItemsById);
export const getNotOptimizedSelectedItems = createSelector(getSelectedItems, items => transformItemDtosToProductItems(items.filter(item => item && !('international_shipping_price' in item))));
export const getVasGalleryPricing = state => localState(state).vasGalleryPricing;
export const getActiveCheckoutModal = state => getVasGalleryCheckout(state).activeModal;
export const getCurrentOrder = state => localState(state).vasGalleryOrder;